<template>
	<!-- TODO 現在の注文データを条件分岐で使用して、このページは削除すること -->
	<!-- TODO 出庫予定日を記入するフォームを追加する -->
	<v-sheet :tile="$vuetify.breakpoint.xs">
		<FunctionTitle title="" />
		<CommonFlame :title="'予定外部品注文データ作成'" class="mt-2">
			<div class="flex-container">
				<div class="fixed">
					<v-menu
						ref="menu"
						v-model="calendar"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								readonly
								outlined
								dense
								:hint="
									order_date
										? '下書きの場合は注文日は保存されません'
										: '設定しない場合は本日の日付が入力されます'
								"
								label="注文日を選択"
								v-model="order_date"
								v-bind="attrs"
								v-on="on"
								class="px-4 mt-4"
								@click="calendar = true"
							/>
						</template>
						<v-date-picker
							v-model="order_date"
							no-title
							scrollable
							@input="calendar = false"
							locale="ja"
						>
						</v-date-picker>
					</v-menu>
					<v-combobox
						ref="combobox"
						class="px-4 mt-4"
						label="発注先を探す(必須)"
						item-text="name"
						item-value="id"
						outlined
						dense
						v-model="supplier"
						:hint="userHint"
						@keyup="setSearchSupplier"
						@change="changeRegularCustomer"
						:items="suppliers"
						:rules="[rules.required]"
					/>

					<v-text-field
						label="発注先担当者"
						class="px-4 mt-4"
						outlined
						readonly
						dense
						hint="発注先を選択すると自動入力されます"
						v-model="supplierPerson"
						:rules="[rules.required]"
					>
					</v-text-field>
					<v-text-field
						label="発注先メールアドレス"
						class="px-4 mt-4"
						outlined
						dense
						readonly
						v-model="supplierEmail"
						:rules="[rules.required]"
						hint="発注先を選択すると自動入力されます"
					>
					</v-text-field>
					<DragUpload @fileShare="fileShare" class="input" />
				</div>
				<div class="scroll">
					<div class="pa-2">
						<div class="mb-2 order-component">
							<h2 class="component-index">
								{{ `注文部品` }}
							</h2>
							<h3 v-if="requirement && requirement.ordered_product">
								製造番号：{{ requirement.ordered_product.product_number }}
							</h3>
							<v-form class="pa-2" ref="form" v-model="valid">
								<v-text-field
									label="部品名(必須)"
									class="mt-4"
									outlined
									dense
									v-model="name"
									:rules="[rules.required]"
								>
								</v-text-field>
								<v-text-field
									label="発注単価(必須)"
									class="mt-2"
									outlined
									hint="半角数字で入力してください"
									v-model="unit_price"
									dense
									:rules="[rules.integer, rules.required]"
								/>

								<p class="mb-8" v-if="unit_price">
									{{ isNaN(unit_price) ? "" : Number(unit_price).toLocaleString("ja-JP") + "円" }}
								</p>
								<v-text-field
									label="発注数量(必須)"
									class="mt-2"
									outlined
									hint="半角数字で入力してください"
									dense
									:rules="[rules.integer, rules.required]"
									v-model="quantity"
								>
								</v-text-field>
								<v-textarea
									type="text"
									class="mt-2"
									label="仕様"
									v-model="remarks"
									outlined
									dense
								/>

								<v-menu
									ref="menu"
									v-model="menu1"
									:close-on-content-click="false"
									transition="scale-transition"
									offset-y
									max-width="290px"
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											readonly
											outlined
											dense
											label="納期(必須)"
											v-bind="attrs"
											v-on="on"
											v-model="expected_receiving_date"
											@click="menu1 = true"
										/>
									</template>
									<v-date-picker
										v-model="expected_receiving_date"
										no-title
										scrollable
										@input="menu1 = false"
										locale="ja"
									>
									</v-date-picker>
								</v-menu>
							</v-form>
						</div>
					</div>
				</div>
			</div>

			<v-card-actions class="mt-8">
				<v-row justify="center">
					<v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 8">
						<v-btn
							color="secondary"
							@click="openCreateDialog()"
							:disabled="!valid || isSupplierAndDateEmpty()"
							block
						>
							注文書作成
						</v-btn>
					</v-col>

					<v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 8">
						<v-btn color="primary" @click="openDraftDialog()" block :disabled="isButtonDisabled()">
							下書き保存
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>

			<ConfirmationDialog
				:dialogTitle="dialogTitle"
				:dialogContent="dialogContent"
				:createProcurementOrderFlag="createProcurementOrderFlag"
				:draftProcurementOrderFlag="draftProcurementOrderFlag"
				:dialog.sync="confirmationDialog"
				@createOrderData="createComponentProcurementOrderData"
				@draftOrderData="draftComponentProcurementOrderData"
				@resetBtnFlag="closeDialog"
			/>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import _ from "lodash"
import rules from "../../helper/rules"
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import common from "../../helper/common"
import ConfirmationDialog from "./components/ComponentProcurementConfirmationDialog.vue"
import DragUpload from "../shared/DragUpload.vue"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
		ConfirmationDialog,
		DragUpload,
	},
	props: {},
	data() {
		return {
			valid: false,
			dialog: false,
			confirmationDialog: false,
			menu1: false,
			calendar: false,
			date: "",
			order_date: "",
			unit_price: "",
			remarks: "",
			quantity: "",
			supplier: "",
			suppliers: [],
			supplierPerson: "",
			supplierEmail: "",
			components: [],
			supplierPerson: "",
			uploadFiles: [],
			order_components: [],
			common: common,
			rules: rules,
			dialogTitle: "",
			dialogContent: "",
			order_data_id: "",
			component: {},
			createProcurementOrderFlag: false,
			draftProcurementOrderFlag: false,
			requirement_id: this.$route.query.requirement_id,
			requirement: {},
			name: "",
			message: "",
			quantity: "",
			expected_receiving_date: "",
		}
	},

	mounted() {
		this.fetchRequirement(this.requirement_id)
	},

	methods: {
		closeDialog() {
			this.createProcurementOrderFlag = false
			this.draftProcurementOrderFlag = false
		},
		fetchRequirement(requirement_id) {
			const headers = authenticate.setHeader()

			axios
				.get(
					`/erp/v1/component_procurement_requirements/component_procurement_requirements/${requirement_id}`,
					{
						headers,
					}
				)
				.then((res) => {
					this.requirement = res.data.requirement
					this.authority_flag = res.data.authority_flag
					this.name = this.componentName(this.requirement)
					this.message = this.refuseText(this.requirement)
					this.quantity = this.NumberOfRequiredComponents(this.requirement)
					this.expected_receiving_date = this.expectedReceivingDate(this.requirement)

					if (this.requirement.ordered_product) {
						this.ordered_product_id = this.requirement.ordered_product.id
						this.requirement.ordered_product.order_components.forEach((order_component) => {
							const value = this.requirement.requirement_values.find((value) => {
								return value.requirement_column.name == "製品部品"
							})
							if (value.value.name == order_component.component.name) {
								this.unit_price = order_component.unit_price
								this.remarks = order_component.remarks
								this.component_id = order_component.component.id
							}
						})
					} else {
						this.component_id = this.componentId(this.requirement)
					}
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		isSupplierAndDateEmpty() {
			return this.order_date == "" || this.supplier == ""
		},
		setSearchSupplier(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return // 上下移動はセレクトの選択に利用するので、利用するので、アクションを起こさない
			this.suppliers = []
			this.supplierKeyword = e.target.value
			clearTimeout(this.searchSupplierTimer) // 連続でタイプした時用に前のタイマーをキャンセル
			if (!this.supplierKeyword.length) return // 0文字の場合はreturn
			this.searchSupplierTimer = setTimeout(this.searchSupplier, 500) // 連続でタイプするとアクセスが走りすぎるため.5秒後に発火
		},
		searchSupplier() {
			const params = {
				q: {
					name_cont: this.supplierKeyword,
				},
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/order_data/search_suppliers", {
					headers,
					params,
				})
				.then((res) => {
					this.suppliers = res.data.suppliers
					this.searchSupplierTimer = null
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		changeRegularCustomer() {
			if (!this.suppliers.includes(this.supplier)) {
				this.errorSupplierFlag = true
				this.supplier = null
				this.$refs.combobox.reset()
			}
			this.supplierPerson = ""
			this.supplierEmail = ""
			if (this.supplier) {
				this.supplierPerson = this.supplier.pic_name
				this.supplierEmail = this.supplier.email
			}
		},
		fileShare(files) {
			this.uploadFiles = files
		},
		fileUpload(file, order_data_id) {
			const headers = authenticate.setHeader()
			headers["content-type"] = "multipart/form-data"
			const formData = new FormData()
			formData.append("order_data_id", order_data_id)
			formData.append("file", file)
			axios
				.post("/erp/v1/order_data/files", formData, { headers })
				.then((res) => {
					if (!res.data.no_error) {
						this.$store.dispatch("setFlash", {
							text: res.data.miss_file + "の作成に失敗しました",
							type: "alert",
						})
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openCreateDialog() {
			this.confirmationDialog = true
			this.createProcurementOrderFlag = true
			this.dialogTitle = "注文データ作成"
			this.dialogContent =
				"注文データを作成して、注文書ページへ遷移します。なお、入庫個数は在庫表に自動反映されます。よろしいですか？"
		},
		openDraftDialog() {
			this.confirmationDialog = true
			this.draftProcurementOrderFlag = true
			this.dialogTitle = "下書き保存"
			this.dialogContent = "下書き保存します。よろしいですか？"
		},

		componentName(requirement) {
			const value = requirement.requirement_values.find((value) => {
				return (
					value.requirement_column.name == "製品部品" || value.requirement_column.name == "部品"
				)
			})
			return value.value.name
		},
		componentId(requirement) {
			const value = requirement.requirement_values.find((value) => {
				return (
					value.requirement_column.name == "製品部品" || value.requirement_column.name == "部品"
				)
			})
			return value.value.id
		},
		expectedReceivingDate(requirement) {
			const value = requirement.requirement_values.find((value) => {
				return value.requirement_column.name == "納期希望日"
			})
			return value.value
		},
		componentQuantity(requirement) {
			const value = requirement.requirement_values.find((value) => {
				return value.requirement_column.name == "数量"
			})
			return value.value
		},

		shippingQuantity(requirement) {
			const value =
				requirement.answer &&
				requirement.answer.answer_values.find((value) => {
					return value.answer_column.name == "在庫引当数量"
				})
			return value ? value.value : 0
		},
		orderQuantity(requirement) {
			const value =
				requirement.answer &&
				requirement.answer.answer_values.find((value) => {
					return value.answer_column.name == "部品注文数量"
				})
			return value ? value.value : 0
		},

		NumberOfRequiredComponents() {
			const quantity = this.componentQuantity(this.requirement) || 0
			const orderQuantity = this.orderQuantity(this.requirement) || 0
			const shippingQuantity = this.shippingQuantity(this.requirement) || 0
			return quantity - orderQuantity - shippingQuantity
		},

		refuseText(requirement) {
			const value = requirement.requirement_values.find((value) => {
				return value.requirement_column.name == "部品調達依頼理由"
			})
			return value.value
		},

		createComponentProcurementOrderData() {
			const headers = authenticate.setHeader()
			const formData = new FormData()
			formData.append("supplier_id", this.supplier.id)
			formData.append("order_date", this.order_date)
			formData.append("requirement_id", this.requirement_id)
			formData.append("name", this.name)
			formData.append("quantity", this.quantity)
			formData.append("unit_price", this.unit_price)
			formData.append("remarks", this.remarks)
			formData.append("expected_receiving_date", this.expected_receiving_date)
			formData.append("component_id", this.component_id)
			if (this.ordered_product_id) {
				formData.append("ordered_product_id", this.ordered_product_id)
			}
			if (this.remarks == null) {
				formData.append("remarks", "")
			}

			axios
				.post(
					"/erp/v1/component_procurement_requirements/component_procurement_order_data",
					formData,
					{ headers }
				)
				.then((res) => {
					this.order_data_id = res.data.order_data_id
					this.$store.commit("setFlash", {
						text: "注文データを作成して、在庫表に部品入庫数を入力しました。",
						type: "notice",
					})
					if (this.uploadFiles) {
						this.uploadFiles.forEach((file) => {
							this.fileUpload(file, this.order_data_id)
						})
					}
					this.$router.push({
						name: "order_data_purchase_order",
						params: { id: this.order_data_id },
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		draftComponentProcurementOrderData() {
			const headers = authenticate.setHeader()
			const formData = new FormData()
			formData.append("supplier_id", this.supplier.id)
			formData.append("order_date", this.order_date)
			formData.append("requirement_id", this.requirement_id)
			formData.append("name", this.name)
			formData.append("quantity", this.quantity)
			formData.append("unit_price", this.unit_price)
			formData.append("remarks", this.remarks)
			formData.append("expected_receiving_date", this.expected_receiving_date)
			formData.append("component_id", this.component_id)
			if (this.ordered_product_id) {
				formData.append("ordered_product_id", this.ordered_product_id)
			}
			if (this.remarks == null) {
				formData.append("remarks", "")
			}

			axios
				.post(
					"/erp/v1/component_procurement_requirements/component_procurement_order_data_draft",
					formData,
					{ headers }
				)
				.then((res) => {
					this.order_data_id = res.data.order_data_id
					this.ordered_product = res.data.ordered_product
					this.$store.commit("setFlash", {
						text: "下書き保存しました。",
						type: "notice",
					})
					if (this.uploadFiles) {
						this.uploadFiles.forEach((file) => {
							this.fileUpload(file, this.order_data_id)
						})
					}
					this.$router.push({
						name: "order_data",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		isButtonDisabled() {
			return !this.supplier
		},
	},
	computed: {
		userHint() {
			if (this.suppliers.length) {
				return ""
			} else if (this.searchSupplierTimer) {
				return "仕入先会社名を取得しています"
			} else if (!this.suppliers.length && this.supplierKeyword) {
				return "該当する会社名が存在していません"
			} else if (this.errorSupplierFlag && !this.supplierKeyword) {
				return "仕入先会社名を入力してください"
			} else {
				return "仕入先会社名を入力してください"
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.component-index {
	font-size: 20px;
	font-weight: bold;
	display: flex;
	align-items: center;
}
.order-component {
	border: solid 2px;
	padding: 20px;
}

.flex-container {
	display: flex;
}
.scroll {
	flex-basis: 60%;
	overflow-y: auto;
	height: 600px;
}
.fixed {
	position: sticky;
	left: 0;
	top: 0;
	z-index: 1;
	flex-basis: 40%;
}
.input {
	margin-top: 56px;
}

@media screen and (max-width: 650px) {
	.flex-container {
		display: block;
	}
	.scroll {
		margin-top: 20px;
		height: auto;
	}
}
</style>
